<template>
  <div class="container-fluid py-4">
    <div class="row" v-if="ok != null">
      <material-alert
          border="top"
          close-icon="$cancel"
          :color="colorAlert()"
          transition="scale-transition"
          :value="ok"
          dismissible
      >
        {{ textAlert() }}
      </material-alert>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="multisteps-form mb-9">
          <div class="row">
            <div class="col-12 col-lg-8 mx-auto my-5"></div>
          </div>
          <div class="row">
            <div class="col-6 col-lg-6 m-auto">
              <div class="card">
                <div
                  class="card-header p-0 position-relative mt-n4 mx-3 z-index-2"
                >
                  <div
                    class="bg-gradient-danger shadow-success border-radius-lg pt-4 pb-3"
                  >
                    <div class="multisteps-form__progress">
                      <button
                        class="multisteps-form__progress-btn"
                        type="button"
                        title="Eliminar Área"
                        :class="activeStep >= 0 ? activeClass : ''"
                      >
                        <span>Eliminar Área</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body" style="display: flex; justify-content: center; align-items: center;">
                  <form class="multisteps-form__form">
                    <!--single form panel-->
                    <h4 class="font-weight-bolder mb-0">{{ textConfirmDelete }}{{ item.name}}?</h4>
                    <div class="multisteps-form__content">
                      <div v-if="error !== ''">
                        <label
                            type="error"
                            :value="alert"
                            class="alert-warning text-bold"
                        >
                          {{ error }}
                        </label>
                      </div>
                      <div class="button-row d-flex mt-4">
                        <material-button
                            type="button"
                            color="danger"
                            variant="danger"
                            class="js-btn-send"
                            @click="getRouteAreaList()"
                        >Cancelar</material-button
                        >
                        <material-button
                            type="button"
                            color="success"
                            variant="gradient"
                            class="ms-auto js-btn-send"
                            @click="deleteArea()"
                        >Confirmar</material-button
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";


export default {
  name: "DeleteArea",
  components: {
    MaterialAlert,
    MaterialButton,
  },
  data() {
    return {
      textConfirmDelete: "¿Desea eliminar el Área: ",
      showMenu: false,
      idItem: -1,
      activeClass: "js-active position-relative",
      activeStep: 0,
      formSteps: 3,
      error: '',
      ok: null,
      alert: false,
      item: {
        name: '',
      }
    };
  },
  watch :{
    "$store.state.area": function(area) {
      this.item = area;
      console.log("Area: ", this.item)
    },
    '$store.state.ok': function (value) {
      if (value){
        this.ok = true;
        setTimeout(this.getRouteAreaList, 3000);
      }
    },
    '$store.state.errorMessage': function (message) {
      this.error = message;
      this.alert = true;
    }
  },
  methods: {
    getRouteAreaList(){
      this.$router.push({ path: "/area/area-list" })
    },
    textAlert() {
      if (this.item.id < 0) {
        return this.ok
            ? "Área eliminada satisfactoriamiente"
            : "Error al intentar eliminar el Área";
      } else {
        return this.ok
            ? "Área eliminada satisfactoriamiente"
            : "Error al intentar eliminar el Área";
      }
    },
    colorAlert() {
      return this.ok ? "success" : "danger";
    },
    deleteArea() {
      this.$store.dispatch('actionsDeleteArea', {
        axios: this.$axios,
        id: this.item.id,
      });
    },
  },
  created() {
    this.idItem = this.$route.params.id !== undefined ? this.$route.params.id : -1;
    this.$store.dispatch('actionsGetArea', {
      'axios': this.$axios,
      'id': this.idItem
    })
  }
};
</script>
<style>
.form-label {
  position: relative;
  display: inline-block;
}


.form-label span {
  position: absolute;
  left: 5px;
  top: 0;
  transition: 0.2s;
  pointer-events: none;
}

.form-label input:focus + span,
.form-label input:not(:placeholder-shown) + span {
  transform: translateY(-25px);
  font-size: 0.8em;
}
</style>
